// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rs_97UcF_s_5YjPp6H9k{flex-direction:column;justify-content:center;align-items:center;gap:16px;width:100%;height:100%;display:flex}.rs_97UcF_s_5YjPp6H9k .s_fqicndKlkVwx6kO749{flex-direction:column;align-items:center;gap:16px;display:flex;position:relative;top:-20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"empty": `rs_97UcF_s_5YjPp6H9k`,
	"emptyTitle": `s_fqicndKlkVwx6kO749`
};
export default ___CSS_LOADER_EXPORT___;
